import Button from "../common/Button";
import heroBackground from "../../images/Hero with background.webp";
import { scroller } from "react-scroll";

export function Hero() {
  return (
    <section id="hero" className="hero-section">
      <div className="hero-wrapper">
        <div className="hero-left">
          <div className="container">
            <div className="hero-copy">
              <h1 className="hero-title">
                Weekly Clarity
                <br />
                Better Decisions
                <br />
                <span className="hero-highlight">Stronger Salon Business</span>
              </h1>

              <p className="hero-description">
                Munafa Engine gives you weekly clarity on revenue, expenses, leakage,
                and real profit — so you can stop guessing and start growing with
                confidence.
              </p>

              <div className="hero-feature-row">
                <div className="hero-feature-item">
                  <div className="hero-feature-icon">📊</div>
                  <span>Weekly Clarity</span>
                </div>
                <div className="hero-feature-item">
                  <div className="hero-feature-icon">💧</div>
                  <span>Leak Detection</span>
                </div>
                <div className="hero-feature-item">
                  <div className="hero-feature-icon">📈</div>
                  <span>Profit Focus</span>
                </div>
                <div className="hero-feature-item">
                  <div className="hero-feature-icon">🔒</div>
                  <span>Confidential & Secure</span>
                </div>
              </div>

              <div className="hero-actions">
                <Button onClick={() => {
                  scroller.scrollTo("request-review", {
                    smooth: true,
                    spy: true,
                    offset: -90,
                  });
                }}>
                  Get My Weekly Salon Clarity
                </Button>
                <button
                  className="btn-secondary"
                  onClick={() => window.open('https://wa.me/15559303709?text=Hi%20Munafa%20Engine%2C%20I%20want%20to%20know%20more%20about%20weekly%20salon%20clarity.', '_blank')}
                >
                  Chat on WhatsApp
                </button>
              </div>

              <p className="hero-footnote">
                <span className="hero-footnote-mark">✓</span>
                No Setup Needed. Just Share Your Weekly Numbers.
              </p>
            </div>
          </div>
        </div>

        <div className="hero-right">
          <div className="hero-visual">
            <div className="hero-image">
              <img
                src={heroBackground}
                alt="Salon hero background"
                className="hero-image-img"
                fetchpriority="high"
              />
              <div className="hero-benefit-panel">
                <div className="hero-benefit-item">
                  <span className="hero-benefit-check">✓</span>
                  <span>
                    Know Your
                    <br />
                    True Profit Each Week
                  </span>
                </div>
                <div className="hero-benefit-item">
                  <span className="hero-benefit-check">✓</span>
                  <span>
                    Spot Leakages
                    <br />
                    Before They Grow
                  </span>
                </div>
                <div className="hero-benefit-item">
                  <span className="hero-benefit-check">✓</span>
                  <span>
                    Track What Matters
                    <br />
                    Without Confusion
                  </span>
                </div>
                <div className="hero-benefit-item">
                  <span className="hero-benefit-check">✓</span>
                  <span>
                    Make Decisions
                    <br />
                    With Confidence
                  </span>
                </div>
                <div className="hero-benefit-item">
                  <span className="hero-benefit-check">✓</span>
                  <span>
                    Grow Your Salon
                    <br />
                    The Right Way
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="hero-wave-wrap">
        <svg
          className="hero-wave"
          viewBox="0 0 1200 60"
          preserveAspectRatio="none"
        >
          <defs>
            <linearGradient id="heroWaveGradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#e89a2c" />
              <stop offset="50%" stopColor="#ffc75f" />
              <stop offset="100%" stopColor="#e89a2c" />
            </linearGradient>
          </defs>
          <path
            d="M0,40 C300,55 600,15 1200,40 L1200,60 L0,60 Z"
            fill="url(#heroWaveGradient)"
          />
        </svg>
      </div>
    </section>
  );
}